<div class="km-service-title">
    <h1>认证专家</h1>
    <ul class="km-service-type">
        {{each ExpertType item index}}
            <li data-id="{{item.TypeValue}}">{{item.TypeName}}</li>
        {{/each}}
    </ul>
    <a class="more-right fr" href="./filter.html?type=2" target="_blank">更多<i class="iconfont icon-gengduo-right"></i></a>
</div>
<div class="km-service-content" id="km-expert-content">
    <div class="card-box clearfix">
        {{each OnlyOneData item i}}     
            <div class="card-module">
                <a href="/home.html?userid={{item.UserID}}" target="_blank">
                    <div class="pic">
                        <div class="snum">{{item.job}}</div>
                        <img class="mask lay-img" lay-src="{{item.DataUrl}}"></img>
                        <!--<img src="{{item.SmallDataUrl}}" data-original="{{item.SmallDataUrl}}"> -->
                        {{if item.CallStatus===2}}
                        <!--放电中-->
                            <label class="callStatus">
                                <img src="../../public/images/callStatus_wink.png">
                            </label>
                        {{/if}}
                    </div>
                </a>
                <div class="info">
                    <div class="headline clearfix">
                        <h2>{{item.NickName}}</h2>
                        {{if item.Sex=='1'}}
                            <span class="malebg">
                                <i class="iconfont icon-nanxing"></i><label class="">{{item.Age}}</label>
                            </span>
                        {{else if item.Sex=='2'}}
                            <span class="femalebg">
                                <i class="iconfont icon-nvxing"></i><label class="">{{item.Age}}</label>
                            </span>
                        {{/if}}
                        {{if item.IsVip}}
                            <span class="vip">
                                <img src="../../public/images/vip.png">
                            </span>
                        {{/if}}
                    </div>
                    <div class='footline'>
                        {{if item.newInterestList}}
                            <ul class="interest-box">
                                {{each item.newInterestList itemm}}
                                    <li><span>{{itemm}}</span></li>
                                {{/each}}
                            </ul>
                        {{/if}}
                    </div>
                </div>
            </div>
        {{/each}}
    </div>
</div>